/**
 * Builds display rows from funnel.by_marker (after normalizeByMarkerRow).
 */

function trimStr(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s;
}

function splitFullName(full) {
  const t = trimStr(full);
  if (!t) return { first: "", last: "" };
  const parts = t.split(/\s+/);
  if (parts.length === 1) return { first: parts[0], last: "" };
  return { first: parts[0], last: parts.slice(1).join(" ") };
}

export function markerFirstLast(row) {
  const fn =
    trimStr(row.first_name) ||
    trimStr(row.given_name) ||
    splitFullName(row.full_name || row.name || row.marker_name).first;
  const ln =
    trimStr(row.last_name) ||
    trimStr(row.surname) ||
    trimStr(row.family_name) ||
    splitFullName(row.full_name || row.name || row.marker_name).last;
  return { firstName: fn || "—", lastName: ln || "—" };
}

export function markerCode(row) {
  const c = trimStr(row.marker_code);
  return c || (row.marker_id != null ? `ID ${row.marker_id}` : "—");
}

export function rowStats(row) {
  const a = Number(row.assigned) || 0;
  const m = Number(row.marked) || 0;
  const pending =
    row.wip != null ? Number(row.wip) : Math.max(0, a - m);
  return { assigned: a, marked: m, pending };
}

export function buildMarkerWorkloadRows(funnel) {
  const list = (funnel && funnel.by_marker) || [];
  return list.map((row, i) => {
    const { assigned, marked, pending } = rowStats(row);
    const { firstName, lastName } = markerFirstLast(row);
    const code = markerCode(row);
    return {
      key: row.marker_id || row.id || row.marker_code || i,
      code,
      firstName,
      lastName,
      assigned,
      marked,
      pending,
      chartLabel:
        [firstName, lastName].filter(x => x && x !== "—").join(" ").trim() ||
        code
    };
  });
}
